import "../css/app.css";
import "../css/print.css";
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";

import * as workPermitFilter from "./workPermitFilter";
import * as icons from "./icons";
import * as common from "./common";
import * as permitMap from "../js/permitMap";
import * as map from "../js/map";
import * as counterSignaturesPage from "../ts/pages/counterSignaturesPage";
import * as recaptcha from "../ts/recaptcha";
import * as components from "../ts/components";
import * as users from "../ts/pages/users";

(window as any).permesso = {};

(window as any).permesso.workPermitFilter = workPermitFilter;
(window as any).permesso.icons = icons;
(window as any).permesso.common = common;

(window as any).permesso.permitMap = permitMap;
(window as any).permesso.map = map;
(window as any).permesso.counterSignaturesPage = counterSignaturesPage;
(window as any).permesso.recaptcha = recaptcha;
(window as any).permesso.components = components;
(window as any).permesso.users = users;
    